<template>
    <div ref="flyItem" class="fly-item">
        <img :src="imgPic" />
    </div>
</template>

<script>
export default {
    name: 'BaseParabolaAnimate',

    props: {
        imgPic: {
            type: String,
            required: true,
        },
    },

    data()
    {
        return {
            isRunning: false,
        }
    },

    methods: {
        addToCartAnimate(startEle, targetEle) {
            if(this.isRunning)
            {
                return;
            }

            //
            this.isRunning = true

            //
            let eleFlyItem = this.$refs.flyItem;
            let eleFlyImg = eleFlyItem.querySelector('img')


            // 现在按钮距离购物车的距离
            let boundStartEle = startEle.getBoundingClientRect()
            let boundTargetEle = targetEle.getBoundingClientRect()
            
            // 中心点的水平垂直距离
            let offsetX =
                boundTargetEle.left +
                boundTargetEle.width / 2 -
                (boundStartEle.left + boundStartEle.width / 2)
            let offsetY =
                boundTargetEle.top +
                boundTargetEle.height / 2 -
                (boundStartEle.top + boundStartEle.height / 2)

            //
            console.log(`offsetX: ${offsetX}, offsetY: ${offsetY}`)

            // 页面滚动尺寸
            let scrollTop =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                0
            let scrollLeft =
                document.documentElement.scrollLeft ||
                document.body.scrollLeft ||
                0

            //
            console.log(`scrollTop: ${scrollTop}, scrollLeft: ${scrollLeft}`)
            
            // 出现与初始定位
            eleFlyItem.style.display = 'block'
            eleFlyItem.style.left =
                boundStartEle.left +
                scrollLeft +
                startEle.clientWidth / 2 +
                'px'
            eleFlyItem.style.top =
                boundStartEle.top +
                scrollTop +
                startEle.clientHeight / 2 +
                'px'

            //
            console.log(`eleFlyItem.style.left: ${eleFlyItem.style.left}, eleFlyItem.style.top: ${eleFlyItem.style.top}`)

            // 开始动画
            eleFlyItem.style.transform = 'translateX(' + offsetX + 'px)'
            eleFlyImg.style.transform = 'translateY(' + offsetY + 'px)'

            //
            setTimeout(() => {
                //
                eleFlyItem.style.display = ''
                eleFlyItem.style.transform = 'translateX(0)'

                //
                eleFlyImg.style.transform = 'translateY(0)'

                //
                this.isRunning = false
            }, 290);
        },
    },
}
</script>

<style lang="scss" scoped>

//
.fly-item {
    position: fixed;
    display: none;
    z-index: 9999999999;
    width: 25px;
    height: 25px;
    transition: transform 0.3s;
    transition-timing-function: linear;
    opacity: 0.5;
}

.fly-item > img {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    transition: transform 0.3s;
    transition-timing-function: cubic-bezier(0.55, 0, 0.85, 0.36);
    border: 1px solid rgb(221, 46, 59);
}

</style>